module.exports = __webpack_public_path__ + "static/media/estrellaGalicia.abca02af.png";